import { classNames } from '../../utils';
import { noop } from '../../utils';
import { useTranslation } from 'react-i18next';

export const Button = ({
    icon,
    label,
    outlined,
    disabled,
    onClick = noop,
    variant = 'primary',
    dataTestId = "",
    block = false,
}: {
    label?: string;
    icon?: JSX.Element;
    outlined?: boolean;
    onClick: () => any;
    dataTestId?: string;
    disabled?: boolean;
    variant?: 'primary' | 'gray' | 'gray-light' | 'transparent' | 'secondary' | 'danger';
    block?: boolean;
}) => {
    const { t } = useTranslation();

    return (
        <button
            type="button"
            data-testid={dataTestId}
            onClick={!disabled ? onClick : noop}
            className={classNames(
                'inline-flex items-center border h-[32px] text-sm leading-4 font-medium rounded-[20px]',
                icon && label ? 'px-4' : '',
                icon ? '' : 'px-3 py-2',
                block ? 'w-full justify-center' : '',
                outlined
                    ? ' border-[#006bc6] shadow-sm text-[#006bc6] bg-white focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-transparent'
                    : 'border-transparent shadow-sm ',
                !outlined && variant === 'primary'
                    ? 'text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-transparent'
                    : !outlined && variant === 'gray'
                    ? 'text-black bg-gray hover:bg-gray-darker focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-transparent'
                    : !outlined && variant === 'gray-light'
                    ? 'text-black-dark bg-gray-100 hover:bg-gray-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-transparent'
                    : !outlined && variant === 'secondary'
                    ? 'text-black-dark bg-secondary hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary'
                    : !outlined && variant === 'danger'
                    ? 'text-white bg-red-700 hover:bg-red-700'
                    : '',
                disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
            )}
        >
            {icon && (
                <div className={classNames(label ? 'mr-1' : '')}>{icon}</div>
            )}
            {t(label || '')}
        </button>
    );
};
